import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-scroll-spy-menu',
  templateUrl: './scroll-spy-menu.component.html',
  styleUrls: ['./scroll-spy-menu.component.scss']
})
export class ScrollSpyMenuComponent implements OnInit {
  @Input()
  scrollContainer: ElementRef;

  constructor() {
    //   this.scrollSpyService.activeSpyTarget.subscribe(
    //     (activeTargetName: string) => console.log(activeTargetName)
    //   );
  }

  ngOnInit(): void {}
}
